import { AlertModalStore } from "./AlertStore";
import { RouteStore } from "./RouteStore";
import { UserStore } from "./UserStore";

export const routeStore = new RouteStore();
export const userStore = new UserStore();
export const alertModalStore = new AlertModalStore();
